import { combineReducers } from 'redux';
import { IReportBuilderState } from "./reducers";
import { compatibility } from './reducers/compatibility';
import { dataFull } from './reducers/dataFull';
import { dataModelNames } from './reducers/dataModelNames';
import { dataOptimized } from './reducers/dataOptimized';
import { dimensions } from './reducers/dimensions';
import { file } from './reducers/file';
import { filters } from './reducers/filters';
import { getLimitRowsTo } from './reducers/limitRowsTo';
import { metrics } from './reducers/metrics';
import { reportOptions } from './reducers/reportOptions';
import { request } from './reducers/request';
import { scopeNames } from './reducers/scopeNames';
import { select } from './reducers/select';
import { selectedDimensions } from './reducers/selectedDimensions';
import { selectedMetrics } from './reducers/selectedMetrics';
import { getStartWithRow } from './reducers/startWithRow';
import { translationsReducer } from './reducers/translations';
export var rootReducer = combineReducers({
    dataFull: dataFull,
    dataOptimized: dataOptimized,
    dimensions: dimensions,
    compatibility: compatibility,
    file: file,
    filters: filters,
    dataModelNames: dataModelNames,
    limitRowsTo: getLimitRowsTo,
    startWithRow: getStartWithRow,
    metrics: metrics,
    request: request,
    scopeNames: scopeNames,
    select: select,
    selectedDimensions: selectedDimensions,
    selectedMetrics: selectedMetrics,
    translations: translationsReducer,
    reportOptions: reportOptions,
});
